var version = {
    "name":      "dativery",
    "buildDateCode": "20250603-185359",
    "buildDate": "Tue Jun 03 2025 18:53:59 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20250603-185359",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;